import type { ComputedRef, InjectionKey, Ref } from 'vue';

import { useIaChrome } from '~/composables/unified/useIaChrome';

const IA_BACK_FRAME_KEY: InjectionKey<Ref<boolean>> = Symbol('ia-back-frame');

/**
 * Whether a page sits under the new information architecture's way back: the button in the bar's
 * column, `py-8` above and below it. The page brings no top spacing of its own there, so the gap
 * under the button is the same on every page, signed in or out. The coach shell and the public
 * layout provide it wherever they draw the button.
 */
export const provideIaBackFrame = (on: Ref<boolean>) => provide(IA_BACK_FRAME_KEY, on);

export const useIaBackFrame = (): Ref<boolean> => inject(IA_BACK_FRAME_KEY, ref(false));

/** Whether a page draws its IA version: inside the coach shell, or under the public layout's way back. */
export const useIaLayout = (): ComputedRef<boolean> => {
  const iaChrome = useIaChrome();
  const underBackButton = useIaBackFrame();

  return computed(() => iaChrome || underBackButton.value);
};
